import React from 'react';

import {useTranslation} from 'react-i18next';

import {MonthPeriod} from '@/widgets/MonthPeriod';
import {PageHeader} from '@/widgets/PageHeader';
import {Page} from '@shared/ui/Page';

import {Wrapper} from './styled';
import {TaxpayersList} from './ui/Table';

export const TaxpayersPage = () => {
    const {t} = useTranslation();

    return (
        <Page>
            <Wrapper>
                <PageHeader title={t('page_taxpayers.title')}>
                    <MonthPeriod />
                </PageHeader>
                <TaxpayersList />
            </Wrapper>
        </Page>
    );
};
